import React, { Component } from "react";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../../_common/AlertModal";
import { connect } from "react-redux";
import "./projAdminLocations.css";
import _ from "lodash";
import { formatThousands } from "../../../../_helpers/numberFormatter";

class LocationDetails extends Component {
  state = {
    showAlert_delLocConfirm: false,
  };

  handleClick_edit = (e) => {
    e.preventDefault();
    this.props.editLocation();
  };

  handleClick_delLocation = (e) => {
    e.preventDefault();
    this.toggleAlert_delLocConfirm();
  };

  toggleAlert_delLocConfirm = () =>
    this.setState({ showAlert_delLocConfirm: !this.state.showAlert_delLocConfirm });

  handleAlert_delLocConfirm = (action) => () => {
    this.toggleAlert_delLocConfirm();
    if (action === "accept") {
      const { deleteLocation } = this.props;
      deleteLocation();
    }
  };

  getLocationTypeDesc = (ltId) => {
    const { locationTypeList } = this.props;
    const lt = (locationTypeList || []).find((lt) => lt.locationTypeId === ltId);
    return lt ? lt.description : "(N/A)";
  };

  renderBidItems = () => {
    const { location } = this.props;
    return (
      <>
        <h5>Bid Items at This Location</h5>
        <div className="pl-0 border pa-loc-details-sublist mb-2">
          <div
            key={`biHeaderKey`}
            className="d-flex flex-row py-1 bg-lightgray pa-loc-details-sublist__table-header"
          >
            <div className="px-1 pa-loc-details-sublist__table-col--item-header">
              <b>Item</b>
            </div>
            <div className="d-flex flex-row px-1 pa-loc-details-sublist__table-col--qty-header text-right">
              <b>Qty</b>
            </div>
            <div className="d-flex flex-row px-1 pa-loc-details-sublist__table-col--unit-header"></div>
          </div>
          {location.bidItems && location.bidItems.length > 0 ? (
            _.orderBy(location.bidItems, "itemNo", "asc").map((bi, index) =>
              this.renderBidItemRow(bi, index)
            )
          ) : (
            <div className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row">
              No data
            </div>
          )}
        </div>
      </>
    );
  };

  renderBidItemRow = (bi, rowIndex) => (
    <div
      key={`locbiRowKey_${rowIndex}`}
      className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row"
    >
      <div className="pr-1 pa-loc-details-sublist__table-col--item-no text-right">
        {bi.itemNo}
      </div>
      <div className="px-1 pa-loc-details-sublist__table-col--item-desc">
        {bi.description}
      </div>
      <div className="px-1 pa-loc-details-sublist__table-col--qty text-right">
        {formatThousands(bi.roadwayEeQuantity + bi.structureEeQuantity)}
      </div>
      <div className="px-1 pa-loc-details-sublist__table-col--unit">
        {bi.unitOfMeasure}
      </div>
    </div>
  );

  renderCcos = () => {
    const { location } = this.props;
    return (
      <>
        <h5 className="mt-2">Change Orders at This Location</h5>
        <div className="pl-0 border pa-loc-details-sublist mb-2">
          <div
            key={`coHeaderKey`}
            className="d-flex flex-row py-1 bg-lightgray pa-loc-details-sublist__table-header"
          >
            <div className="px-1 w-100">
              <b>Change Order</b>
            </div>
          </div>
          {location.ccos && location.ccos.length > 0 ? (
            _.orderBy(location.ccos, "ccoNo", "asc").map((co, index) =>
              this.renderCcoRow(co, index)
            )
          ) : (
            <div className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row">
              None
            </div>
          )}
        </div>
      </>
    );
  };

  renderCcoRow = (co, rowIndex) => (
    <div
      key={`loccoRowKey_${rowIndex}`}
      className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row"
    >
      <div className="pr-1 w-100">
        <span>{`#${co.ccoNo} - ${co.description || "(Desc. N/A)"}`}</span>
      </div>
    </div>
  );

  renderPendingIssues = () => {
    const { location } = this.props;
    return (
      <>
        <h5 className="mt-2">Pending Issues at This Location</h5>
        <div className="pl-0 border pa-loc-details-sublist mb-2">
          <div
            key={`piHeaderKey`}
            className="d-flex flex-row py-1 bg-lightgray pa-loc-details-sublist__table-header"
          >
            <div className="px-1 w-100">
              <b>Pending Issue</b>
            </div>
          </div>
          {location.pendingIssues && location.pendingIssues.length > 0 ? (
            _.orderBy(location.pendingIssues, "pendingIssueNo", "asc").map((pi, index) =>
              this.renderPendingIssueRow(pi, index)
            )
          ) : (
            <div className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row">
              None
            </div>
          )}
        </div>
      </>
    );
  };

  renderPendingIssueRow = (pi, rowIndex) => (
    <div
      key={`locpiRowKey_${rowIndex}`}
      className="d-flex flex-row py-1 pl-1 pa-loc-details-sublist__table-row"
    >
      <div className="pr-1 w-100">
        <span>{`#${pi.pendingIssueNo} - ${pi.title || "(Desc. N/A)"}`}</span>
      </div>
    </div>
  );

  render() {
    const { showAlert_delLocConfirm } = this.state;
    const { permissions, location, fetching } = this.props;
    return (
      <React.Fragment>
        {location ? (
          <React.Fragment>
            <h3 className="card-title mx-0">{location.name}</h3>
            <h5 className="card-subtitle text-muted mx-0">
              {this.getLocationTypeDesc(location.locationTypeId)}
            </h5>
          </React.Fragment>
        ) : fetching ? (
          <h5 className="text-muted">Loading...</h5>
        ) : (
          <h5 className="text-muted">No location selected</h5>
        )}
        {location && (
          <React.Fragment>
            <div className="row pl-0 mx-0 mt-2">
              <div className="col pl-0">
                <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Description:</b>
                      </div>
                      <div className="col pl-1">{location.description || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Sta/Offset:</b>
                      </div>
                      <div className="col pl-1">
                        {location.combinedAlignment || "(N/A)"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Co-Rte-PM:</b>
                      </div>
                      <div className="col pl-1">{location.coRtePm || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Bridge No.:</b>
                      </div>
                      <div className="col pl-1">{location.bridgeNo || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Sublocations:</b>
                      </div>
                      <div className="col px-1">
                        {location.sublocations && location.sublocations.length > 0 ? (
                          location.sublocations.map((sl, rowIndex) => (
                            <div
                              key={`sublocRowKey_${rowIndex}`}
                              className="list-group-item py-0 pl-1"
                            >
                              <div className="row">
                                <div className="col pr-1">
                                  <span>{sl.name}</span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            key={`sublocRowKey_0`}
                            className="list-group-item py-1 pl-1"
                          >
                            <div className="row">
                              <div className="col pr-1">(No sublocations)</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-row form-group">
              <button
                type="button"
                name="editLocationDetails"
                id="editLocationDetails"
                className="btn btn-secondary mr-2"
                onClick={this.handleClick_edit}
                disabled={
                  !permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
                  location.isGeneric
                }
              >
                Edit...
              </button>
              <button
                type="button"
                name="deleteLocation"
                id="deleteLocation"
                className="btn btn-danger mr-2"
                onClick={this.handleClick_delLocation}
                disabled={
                  !permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
                  location.hasLinks
                }
              >
                Delete
              </button>
              {location.hasLinks && (
                <button
                  type="button"
                  name="locInUse"
                  id="locInUse"
                  className="btn btn-link text-muted p-1"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                  In Use
                </button>
              )}
            </div>
            <hr />
            {this.renderBidItems()}
            {this.renderCcos()}
            {this.renderPendingIssues()}
          </React.Fragment>
        )}
        {showAlert_delLocConfirm && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to delete this location?"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_delLocConfirm}
            showAlertModal={showAlert_delLocConfirm}
            toggleAlertModal={this.toggleAlert_delLocConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationTypeList: state.feederLists.locationTypeList || null,
  location: state.locations.openLocationDetails[ownProps.projectId]
    ? state.locations.openLocationDetails[ownProps.projectId][ownProps.locationId] || null
    : null,
  fetching: state.locations.fetching,
});

export default connect(mapStateToProps)(LocationDetails);
